import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

function ModalMyAvant({ classNames, children, handleModal, backgroundImage }) {
  const [backgroundStyle, setBackgroundStyle] = useState(null)

  useEffect(() => {
    const style = {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      width: '100%',
      backgroundImage: `url(${backgroundImage?.url})`
    }

    setBackgroundStyle(style)
  }, [backgroundImage])

  return (
    <div>
      <Helmet>
        <body className="myavant-modal__noscroll" />
      </Helmet>
      <div
        className={classNames.container}
        onClick={handleModal}
        role="button"
        tabIndex={0}
        aria-current="true"
        onKeyDown={handleModal}
      >
        <div
          className={classNames.content}
          style={backgroundImage ? backgroundStyle : null}
          // do not close modal if anything inside modal content is clicked
          onClick={e => {
            e.stopPropagation()
          }}
          onKeyDown={e => {
            e.stopPropagation()
          }}
          role="presentation"
        >
          <div className={classNames.message}>{children}</div>
        </div>
      </div>
    </div>
  )
}

ModalMyAvant.defaultProps = {
  handleModal: () => {},
  backgroundImage: null
}

ModalMyAvant.propTypes = {
  classNames: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  handleModal: PropTypes.func,
  backgroundImage: PropTypes.object
}

export default ModalMyAvant
